export const MigrosFitnessTheme = {
  name: 'migrosFitness Theme',
  themeId: 'migrosFitness',
  fonts: {
    sizes: {
      heading: {
        xsmall: '20px',
        small: '20px'
      }
    }
  }
};